import { apiFetch } from '@/lib/api';

export interface SensitiveGrant {
  id: string;
  grantee_user_id: string;
  grantee: string;
  scope: 'user' | 'tenant';
  subject_user_id: string | null;
  subject: string | null;
  justification: string;
  created_at: string;
  expires_at: string;
  revoked_at: string | null;
  revoked_by: string | null;
}

export interface UnlockDraft {
  justification: string;
  scope: 'user' | 'tenant';
  duration_minutes: number;
}

export const SENSITIVE_ACCESS_CHANGED = 'employment:sensitive-access-changed';
export function sensitiveAccessChanged() {
  window.dispatchEvent(new Event(SENSITIVE_ACCESS_CHANGED));
}

export function activeUnlocks(signal?: AbortSignal) {
  return apiFetch<{ data: SensitiveGrant[] }>('/employment/sensitive-unlock/active', { signal });
}

export function unlockSensitive(draft: UnlockDraft, subjectId: string) {
  return apiFetch<{ data: SensitiveGrant }>('/employment/sensitive-unlock', {
    method: 'POST', body: JSON.stringify({ ...draft, ...(draft.scope === 'user' ? { user_id: subjectId } : {}) }),
  });
}

export function endUnlock(id: string) {
  return apiFetch<{ data: SensitiveGrant }>(`/employment/sensitive-unlock/${encodeURIComponent(id)}/end`, { method: 'POST' });
}
